import Harvey1 from './assets/harvey1.jpg';
import Harvey2 from './assets/harvey2.jpg';
import Harvey3 from './assets/harvey3.jpg';
import Shea1 from './assets/shea1.jpg';
import Shea2 from './assets/shea2.jpg';
import Spratt13 from './assets/spratt13.jpg';
import ward from './assets/ward.jpg';
import jeremy from './assets/jeremy.jpg';



export const succulentsDB = [
    {
        id: 1,
        picture: Harvey1
    },
    {
        id: 2,
        picture: Harvey2
    },
    {
        id: 3,
        picture: Harvey3
    },
    {
        id: 4,
        picture: Shea1
    },
    {
        id: 5,
        picture: Shea2
    },
    {
        id: 6,
        picture: Spratt13
    },
    {
        id: 7,
        picture: ward
    },
    {
        id: 8,
        picture: jeremy
    }
]